"use client";

import { useRouter } from "next/navigation";
import { ArrowRight, Home, SearchX } from "lucide-react";

export default function CustomNotFoundPage() {
  const router = useRouter();
  const handleBack = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
      return;
    }
    router.push("/");
  };

  return (
    <main className="relative min-h-screen overflow-hidden bg-slate-950 px-4 py-16 text-slate-100">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 right-[-140px] h-72 w-72 rounded-full bg-cyan-500/15 blur-3xl" />
        <div className="absolute -bottom-24 left-[-140px] h-72 w-72 rounded-full bg-indigo-500/15 blur-3xl" />
      </div>

      <div className="relative mx-auto flex min-h-[70vh] w-full max-w-2xl items-center justify-center">
        <section className="w-full rounded-3xl border border-slate-800 bg-slate-900/70 p-8 text-center shadow-2xl shadow-black/30 backdrop-blur-sm md:p-10">
          <div className="mb-5 flex justify-center">
            <span className="inline-flex h-20 w-20 items-center justify-center rounded-2xl border border-rose-500/40 bg-rose-500/10">
              <SearchX className="h-10 w-10 text-rose-300" />
            </span>
          </div>

          <p className="mb-2 text-xs font-bold tracking-[0.2em] text-slate-400">ERROR 404</p>
          <h1 className="mb-4 text-2xl font-extrabold text-slate-50 md:text-4xl">صفحه یافت نشد</h1>
          <p className="mx-auto mb-8 max-w-lg text-sm leading-7 text-slate-300 md:text-base">
            آدرسی که وارد کرده‌اید معتبر نیست، حذف شده یا دسترسی به آن وجود ندارد.
          </p>

          <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={handleBack}
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-rose-500/40 bg-rose-600 px-5 py-2.5 text-sm font-bold text-white transition hover:bg-rose-500"
            >
              <ArrowRight className="h-4 w-4" />
              بازگشت به صفحه قبل
            </button>
            <button
              type="button"
              onClick={() => router.push("/")}
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-700 bg-slate-900 px-5 py-2.5 text-sm font-bold text-slate-200 transition hover:bg-slate-800"
            >
              <Home className="h-4 w-4" />
              رفتن به صفحه اصلی
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
